import React, { useState, useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'

const CartItem = ({ item }) => {
    const isGift = useCallback((item) => {
        return item?.DETAIL_PAGE_URL?.split('/').includes('podarki');
    })

    return <div className={ `happy-cart-small__item` } data-id={ item.ID } data-product-id={ item.PRODUCT_ID }>
        <div className="happy-cart-small__item-image">
            <a href={ item.DETAIL_PAGE_URL } className="happy-cart-small__item-image-link" style={{ backgroundImage : `url( ${ item.PREVIEW_PICTURE } )` }}></a>
        </div>
        <div className="happy-cart-small__item-content">
            <div className="happy-cart-small__item-title">
                <a href={ item.DETAIL_PAGE_URL } className="happy-cart-small__item-title-link">{ item.NAME }</a>
            </div>
            
            <div className="happy-cart-small__price">
                { !isGift(item) ? <><span className="happy-cart-small__price-gray">{ item.QUANTITY } шт. x { item.PRICE_FORMAT }</span> = { item.SUMMARY_FORMAT }</>
                : <><span className="happy-cart-small__price-gray">{ item.QUANTITY } шт. x 1 ₽ </span> = 1 ₽</>}
            </div>

            { item.DISCOUNT_PRICE > 0 ? <div className="happy-cart-small__item-discount">
            <span className="happy-cart-small__item-discount-strike">{ item.BASE_PRICE_SUMMARY_FORMAT }</span> <span className="happy-cart-small__item-discount-percent">Скидка -{ parseInt(Math.round(item.DISCOUNT_PERCENT)) } %</span>
            </div> : null}
        </div>
    </div>
}

export default CartItem